export const about = {
  init: function () {    

    $('.filter-clinic').on('click', function(e){
        e.preventDefault();
        const target = $(this).attr('data-filter');
        $('.list-item').removeClass('active');
        $(this).parent().addClass('active');
        $('.clinics-list-item').addClass('hiding');
        setTimeout(function(){
            $('.clinics-list-item').removeClass('hiding');
            $('.clinics-list-item').removeClass('active');
            $(`.region-${target}`).addClass('active');
            $(`.region-${target}.active`).each(function(e){
              $(this).find('.clinics-count').html((e + 1).toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false}));
            });
        }, 300)
    });
    $('.filter-select-group').on('change', function(e) {
      const target = $(this).find(":selected").val();
      $('.list-item').removeClass('active');
      $('.clinics-list-item').addClass('hiding');
      setTimeout(function(){
          $('.clinics-list-item').removeClass('hiding');
          $('.clinics-list-item').removeClass('active');
          $(`.region-${target}`).addClass('active');
          $(`.region-${target}.active`).each(function(e){
            $(this).find('.clinics-count').html((e + 1).toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false}));
          });
      }, 300)
    })
  }
};
